import { render, staticRenderFns } from "./ToolUserOrderInfo.vue?vue&type=template&id=0b47f5c0&scoped=true&"
import script from "./ToolUserOrderInfo.vue?vue&type=script&lang=js&"
export * from "./ToolUserOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./ToolUserOrderInfo.vue?vue&type=style&index=0&id=0b47f5c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b47f5c0",
  null
  
)

export default component.exports